exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.newRealTask{width:100%;height:100%\n}\n", "", {"version":3,"sources":["/data/data/jenkins/workspace/edu-gxzx-web-pro-new-study/src/views/newRealTask/index.vue"],"names":[],"mappings":";AA4BA,aACE,WACA,WAAY;CACb","file":"index.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.newRealTask {\n  width: 100%;\n  height: 100%;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-29f3381c","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/newRealTask/index.vue
// module id = KXid
// module chunks = 96